let browserStorageService = localStorage;

let isLocalStorageSupported = true;
try {
    localStorage.setItem('localStorageTest', '1');
    localStorage.removeItem('localStorageTest');
} catch(e) {
    isLocalStorageSupported = false;
}

if (!isLocalStorageSupported) {
    browserStorageService = <Storage>{};
    browserStorageService['structureLocalStorage'] = {};
    browserStorageService.setItem = (key, value) => {
        browserStorageService['structureLocalStorage'][key] = value;
    };
    browserStorageService.getItem = (key) => {
        if (browserStorageService['structureLocalStorage'][key] === undefined) {
            return null;
        }
        return browserStorageService['structureLocalStorage'][key];
    };
    browserStorageService.removeItem = function (key) {
        browserStorageService['structureLocalStorage'][key] = undefined;
    }
}

export default browserStorageService;
